import { Parish } from '@/Domain/Localization/Parish'

export class ParishDto {
  private _code: number
  private _name: string

  public static fromParish (parish: Parish): ParishDto {
    return new this(parish.code(), parish.name())
  }

  constructor (code: number, name: string) {
    this._code = code
    this._name = name
  }

  get code (): number {
    return this._code
  }

  get name (): string {
    return this._name
  }
}
